import api from "./api";

export default class ResidencyApi {
  static async List(data) {
    return await api.get(`residency`, data);
  }

  static async Get(id) {
    return await api.get(`residency/${id}`);
  }
}
